import AxiosStatic from 'axios';
import { message } from 'antd';

const catchError = (fallback: string) => (err: Error) =>
  void message.error(
    (AxiosStatic.isAxiosError(err) && err?.response?.data?.message) || fallback
  );

export default catchError;
